import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getMissionUniversalQnsAction = createAsyncThunk(
    'get-mission-universal-qns',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-mission-universal-qns-ans`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getMissionUniversalQnsSlice = createSlice({
    name: 'get-mission-universal-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getMissionUniversalQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getMissionUniversalQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getMissionUniversalQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getMissionUniversalQnsReducer = getMissionUniversalQnsSlice.reducer    